import {showCommunicationError, showNotFoundToast, showSuccess} from 'helpers/alerts';
import {t} from 'i18next';
import {action, makeObservable, observable, runInAction} from 'mobx';
import {redirectTo} from 'routing/browserHistory';
import {AppRoutePaths} from 'routing/Routes';
import {EmployeeDto, EmployeeUpdateRequest, SortDirection, UserRole} from '../../../../../../PRMGApiClient';
import {Api} from '../../../../../../PRMGApiClient/ApiClient';

export class EmployeeState {
  @observable
  item: EmployeeUpdateRequest = {
    id: undefined,
    userName: undefined,
    firstName: undefined,
    lastName: undefined,
    isActive: undefined,
    password: undefined,
    userRole: UserRole.Admin,
    phoneNumber: undefined,
    phoneNumberPrefix: undefined,
  };

  @observable
  tasks = {};

  @observable
  pageNumber: number = 1;

  @observable
  pageSize: number = 10;

  @observable
  total: number = 0;

  sortPropertyName: string = 'id';

  sortDirection: SortDirection = SortDirection.Asc;

  @observable
  isLoading = false;

  constructor() {
    makeObservable(this);
  }

  loadEmployee(id: number | undefined) {
    if (!id) return;

    Api.Employee.apiEmployeeGetIdGet({
      id: id,
    })
      .then((res) => {
        if (res.content) {
          runInAction(() => {
            this.item = {
              ...res.content,
            };
          });
        } else {
          showNotFoundToast();
          setTimeout(() => redirectTo(AppRoutePaths.employees.url), 1000);
        }
      })
      .catch(showCommunicationError);
  }

  @action
  save(payload: EmployeeDto): void {
    this.item = payload;
    this.item.id ? this.updateEmployee() : this.addEmployee();
  }

  @action
  addEmployee(): void {
    this.isLoading = true;
    Api.Employee.apiEmployeeAddPost({
      employeeCreateRequest: this.item,
    })
      .then(() => {
        showSuccess(t('Employee added'));
        setTimeout(() => redirectTo(AppRoutePaths.employees.url), 1000);
      })
      .catch(showCommunicationError)
      .finally(() => (this.isLoading = false));
  }

  @action
  updateEmployee(): void {
    this.isLoading = true;
    console.log(this.item.id === 21);
    console.log(this.item.userName);
    Api.Employee.apiEmployeeUpdatePut({
      employeeUpdateRequest: this.item,
    })
      .then(() => {
        showSuccess(t('Changes saved'));
        setTimeout(() => redirectTo(AppRoutePaths.employees.url), 1000);
      })
      .catch(showCommunicationError)
      .finally(() => (this.isLoading = false));
  }

  @action
  deleteEmployee() {
    if (!this.item.id) return;

    this.isLoading = true;
    Api.Employee.apiEmployeeDeleteIdDelete({
      id: this.item.id,
    })
      .then(() => {
        showSuccess(t('Employee deleted'));
        setTimeout(() => redirectTo(AppRoutePaths.employees.url), 1000);
      })
      .catch(showCommunicationError)
      .finally(() => (this.isLoading = false));
  }
}
